// The Stats window's arithmetic, kept apart from storage and the network so it
// can be tested on its own (lib/history.ts reads the record and calls this).

export type GameKey = 'running-order' | 'call-sheet';

export interface DeviceStats {
  played: number;
  won: number;
  dist: number[];      // solved on guess 1, 2, 3
  missed: number;
  streak?: number;
  max?: number;
}

/**
 * Played, won, the distribution — and for the daily, the streak.
 *
 * **Only games that count**: a daily played on its day, a Call Sheet's first
 * completion. An archive round marks its tile and nothing else.
 *
 * **A streak is a run of dailies solved on consecutive days**, and dailies are
 * numbered by day, so it is a run of consecutive numbers. The current streak is
 * the run ending at the most recent one counted — and only while that one is
 * today's or yesterday's: a day missed ends it. `today` is today's daily, or
 * null where it is not known, in which case the run is taken as it stands.
 */
/**
 * Played, won, the distribution — and for the daily, the streak.
 *
 * **Only games that count**: a daily played on its day, a Call Sheet's first
 * completion. An archive round marks its tile and nothing else.
 *
 * **A streak is a run of dailies solved on consecutive days**, and dailies are
 * numbered by day, so it is a run of consecutive numbers. The current streak is
 * the run ending at the most recent one counted — and only while that one is
 * today's or yesterday's: a day missed ends it. `today` is today's daily, or
 * null where it is not known, in which case the run is taken as it stands.
 */
export function statsFrom(game: GameKey, record: Map<number, { solvedOn: number | null; counts: boolean }>,
                          today: number | null): DeviceStats | null {
  const counted = [...record].filter(([, o]) => o.counts).sort((a, b) => a[0] - b[0]);
  if (!counted.length) return null;
  const dist = [0, 0, 0];
  let missed = 0;
  for (const [, o] of counted) {
    if (o.solvedOn && o.solvedOn >= 1 && o.solvedOn <= 3) dist[o.solvedOn - 1]! += 1;
    else missed += 1;
  }
  const stats: DeviceStats = { played: counted.length, won: counted.length - missed, dist, missed };
  if (game !== 'running-order') return stats;

  let max = 0, run = 0, prev = -1;
  for (const [n, o] of counted) {
    run = o.solvedOn ? (n === prev + 1 ? run + 1 : 1) : 0;
    max = Math.max(max, run);
    prev = n;
  }
  const last = counted[counted.length - 1]!;
  const current = today === null || last[0] >= today - 1 ? run : 0;
  return { ...stats, streak: current, max };
}
